var exports = {
  "u": "xfb577c5e--fd3bce--section",
};

module.exports = exports;
